/* Report preparation guard. Other products and the existing cart bump stay in place. */
(() => {
  const variant='65413936087389', origin='https://quiz.marquisdemayfair.com';
  let inspecting=null, timer;
  const buttons=()=>[...document.querySelectorAll('button[name="checkout"],input[name="checkout"]')];
  const markers=()=>[...document.querySelectorAll('[data-mdm-report-cart]')];
  function message(text) {
    for(const marker of markers()){
      marker.replaceChildren();
      if(!text)continue;
      const p=document.createElement('p');p.textContent=text;marker.append(p);
      const a=document.createElement('a');a.href=origin+'/';a.textContent='Prepare my report';marker.append(a,document.createTextNode(' · '));
      const b=document.createElement('a');b.href=origin+'/recover';b.textContent='Already paid? Recover my report';marker.append(b);
    }
  }
  async function inspect() {
    if(inspecting)return inspecting;
    inspecting=(async()=>{
      const cartResponse=await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!cartResponse.ok)throw Error('CART_UNAVAILABLE');
      const cart=await cartResponse.json(), quiz=cart.items.filter(i=>String(i.variant_id)===variant);
      if(!quiz.length){message('');buttons().forEach(b=>{b.disabled=!cart.item_count;});return true;}
      buttons().forEach(b=>{b.disabled=true;});
      const reports=quiz.map(i=>{
        let token='';try{const u=new URL(i.properties?.['Private report link']);if(u.origin===origin&&u.pathname==='/')token=new URLSearchParams(u.hash.slice(1)).get('report')||'';}catch{}
        return {id:i.properties?._report_id,token,quantity:i.quantity};
      });
      const response=await fetch(origin+'/api/create-checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'validate_cart',reports}),signal:AbortSignal.timeout(12000)});
      if(!response.ok)throw Error('REPORT_CHECK_UNAVAILABLE');
      const result=await response.json();
      if(result.ready){message('Your report is saved and ready for payment.');buttons().forEach(b=>{b.disabled=false;});return true;}
      message(result.reason==='ALREADY_PAID'?'This report has already been paid for. Recover it instead of paying again. Remove it from the cart to buy other items.':'This report needs to be prepared before payment, and each report should appear once. Remove the unprepared or duplicate report from your cart, then prepare your report.');
      return false;
    })().catch(()=>{buttons().forEach(b=>{b.disabled=true;});message('We cannot verify your report right now. Please try again later; do not pay again.');return false;}).finally(()=>{inspecting=null;});
    return inspecting;
  }
  async function freshInspect(){if(inspecting)await inspecting;return inspect();}
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    const id=form.querySelector('[name="id"]')?.value;
    if(String(id)===variant&&new URL(form.action,location.href).pathname.includes('/cart/add')){
      event.preventDefault();event.stopImmediatePropagation();location.assign(origin+'/');return;
    }
    if(event.submitter?.name!=='checkout')return;
    if(form.dataset.mdmVerified==='yes'){delete form.dataset.mdmVerified;return;}
    event.preventDefault();event.stopImmediatePropagation();
    if(await freshInspect()){form.dataset.mdmVerified='yes';form.requestSubmit(event.submitter);}
  },true);
  document.addEventListener('click',async event=>{
    const a=event.target.closest?.('a[href]');if(!a)return;
    const u=new URL(a.href,location.href);
    if(u.origin!==location.origin)return;
    if((u.pathname.includes('/cart/add')&&u.searchParams.get('id')===variant)||u.pathname.includes(`/cart/${variant}:`)){
      event.preventDefault();event.stopImmediatePropagation();location.assign(origin+'/');return;
    }
    if(u.pathname==='/checkout'){
      event.preventDefault();event.stopImmediatePropagation();if(await freshInspect())location.assign(u.href);
    }
  },true);
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>{if(markers().length)inspect();},250);}
  // Cart sections are replaced after quantity changes and bump selection.
  new MutationObserver(changes=>{if(changes.some(c=>[...c.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-mdm-report-cart]')||n.querySelector?.('[data-mdm-report-cart]')))))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
  schedule();
})();
